import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import { legalFormValidation } from '../legalFormValidation';
import Flex from '../../../components/common/Flex';
import { useInsertRealOrLegalMutation } from '@/app/Purchase/api/ordersApi';
import { errorMessage, successMessage } from '@/utils/toast';
import IconAlert from '@/components/common/IconAlert';
import type { LegalFormProps, LegalFormValues } from '../types/purchaseTypes';

const emptyState: LegalFormValues = {
  name: '',
  phone_number: '',
  province: '',
  city: '',
  postal_code: '',
  address: '',
  national_id: '',
  // FOR COMPANIES
  economical_number: '',
  registration_code: ''
};
function LegalForm({ handleClose, init, onSuccess }: LegalFormProps) {
  const [isAlertDismissed, setIsAlertDismissed] = useState(false);
  const [isAlert2Dismissed, setIsAlert2Dismissed] = useState(false);
  const [agreedWithTerms, setAgreedWithTerms] = useState(false);
  const [isAgreedWithTermsError, setIsAgreedWithTermsError] = useState(false);
  const [agreedWithTerms1, setAgreedWithTerms1] = useState(false);
  const [isAgreedWithTermsError1, setIsAgreedWithTermsError1] = useState(false);
  const [isLegal, setIsLegal] = useState(false);
  const [initialValuesState, setInitialValuesState] = useState(
    init || emptyState
  );
  const [max, setmax] = useState(11);
  const [insertRealOrLegal] = useInsertRealOrLegalMutation();

  useEffect(() => {
    if (init && init.registration_code !== '') setIsLegal(true);
  }, [init]);

  return (
    <div>
      <IconAlert
        dismissible
        onClose={() => setIsAlertDismissed(true)}
        show={!isAlertDismissed}
        variant="info"
        className="mb-3"
      >
        فاکتور سفارشات پس از ثبت اطلاعات، تا آخر هر ماه در سامانه
        مودیان ثبت خواهد شد، در صورت عدم ثبت اطلاعات تمام سفارشات به صورت تجمیعی
        و بدون بردن نام شخص/شرکت جنابعالی به سامانه ارسال خواهد شد.{' '}
      </IconAlert>
      {isLegal && (
        <IconAlert
          dismissible
          onClose={() => setIsAlert2Dismissed(true)}
          show={!isAlert2Dismissed}
          variant="info"
          className="mb-3"
        >
          در صورت عدم تطابق اطلاعات حقوقی واردشده با سامانه{' '}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://ilenc.ssaa.ir"
          >
            ilenc.ssaa.ir&nbsp;
          </a>
          ، صدور فاکتور امکان‌پذیر نخواهد بود و مسئولیت عدم صدور با شما خواهد
          بود.
        </IconAlert>
      )}
      <Row className="g-2 mb-3">
        <Form.Group as={Col} sm={6}>
          <div className="d-flex align-items-center gap-4">
            <Form.Label className="mb-0">نوع فاکتور:</Form.Label>
            <div className="d-flex gap-4">
            <Form.Check type="radio" id="factorTypeReal" className="mb-0">
              <Form.Check.Input
                type="radio"
                name="factorType"
                value="real"
                checked={!isLegal}
                onChange={() => {
                  setInitialValuesState({
                    ...initialValuesState
                    // national_id: '',
                    // name: ''
                  });
                  setIsLegal(false);
                }}
              />
              <Form.Check.Label
                htmlFor="factorTypeReal"
                className="mb-0 cursor-pointer ms-1"
              >
                حقیقی
              </Form.Check.Label>
            </Form.Check>
            <Form.Check type="radio" id="factorTypeLegal" className="mb-0">
              <Form.Check.Input
                type="radio"
                name="factorType"
                value="legal"
                checked={isLegal}
                onChange={() => {
                  setInitialValuesState({
                    ...initialValuesState
                  });
                  setIsLegal(true);
                }}
              />
              <Form.Check.Label
                htmlFor="factorTypeLegal"
                className="mb-0 cursor-pointer ms-1"
              >
                حقوقی
              </Form.Check.Label>
            </Form.Check>
            </div>
          </div>
        </Form.Group>
      </Row>

      <hr className="my-3" />
      <Formik
        onSubmit={async (values, actions) => {
          const digitKeys = [
            'registration_code',
            'national_id',
            'economical_number',
            'postal_code'
          ];
          const convertedValues = {
            ...values,
            ...Object.fromEntries(
              digitKeys
                .filter(key => key in values)
                .map(key => [key, String(values[key]).toEnglishDigit()])
            )
          };
          const legalObj = isLegal
            ? {
                economical_number: values.national_id
              }
            : {
                registration_code: ''
              };
          !agreedWithTerms || !agreedWithTerms1
            ? (() => {
                if (!agreedWithTerms) setIsAgreedWithTermsError(true);
                if (!agreedWithTerms1) setIsAgreedWithTermsError1(true);
              })()
            : insertRealOrLegal({ ...convertedValues, ...legalObj })
                .unwrap()
                .then(response => {
                  if (response?.success) {
                    actions.resetForm();
                    if (onSuccess) {
                      onSuccess();
                      return;
                    }
                    successMessage(
                      'اطلاعات با موفقیت اضافه شد‌‌، مجدد درخواست پیش‌فاکتور بدید.'
                    );
                    handleClose();
                  } else {
                    console.error('خطا در ثبت اطلاعات فرم فاکتور', response);
                    errorMessage('خطا در ثبت اطلاعات فاکتور');
                  }
                })
                .catch(err => {
                  console.error('خطا در ثبت اطلاعات فرم فاکتور', err);
                  errorMessage('خطا در ثبت اطلاعات فاکتور');
                });
        }}
        initialValues={initialValuesState}
        enableReinitialize
        validationSchema={legalFormValidation(isLegal)}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          resetForm,
          handleSubmit,
          submitForm,
          validateField,
          setFieldValue,
          isSubmitting,
          validateForm,
          setValues
        }) => {
          useEffect(() => {
            validateForm();
          }, [isLegal]);
          return (
            <Form onSubmit={handleSubmit}>
              <Row className="g-2 mb-3">
                <Form.Group as={Col} sm={6}>
                  {
                    <Form.Label>
                      {isLegal ? 'نام شرکت' : 'نام و نام خانوادگی'}
                    </Form.Label>
                  }
                  <Form.Control
                    placeholder={''}
                    isInvalid={touched.name && errors.name}
                    isValid={touched.name && !errors.name}
                    value={values.name}
                    name="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="text"
                  />
                  <Form.Control.Feedback
                    type={errors.name ? 'invalid' : 'valid'}
                  >
                    {touched.name && errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} sm={6}>
                  {<Form.Label>{isLegal ? 'شناسه ملی' : 'کد ملی'}</Form.Label>}
                  <Form.Control
                    placeholder={''}
                    isInvalid={touched.national_id && errors.national_id}
                    isValid={touched.national_id && !errors.national_id}
                    value={values.national_id}
                    name="national_id"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="text"
                  />
                  <Form.Control.Feedback
                    type={errors.national_id ? 'invalid' : 'valid'}
                  >
                    {touched.national_id && errors.national_id}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="g-2 mb-3">
                {isLegal && (
                  <Form.Group as={Col} sm={6}>
                    <Form.Label>کد ثبت</Form.Label>
                    <Form.Control
                      placeholder={''}
                      isInvalid={
                        touched.registration_code && errors.registration_code
                      }
                      isValid={
                        touched.registration_code && !errors.registration_code
                      }
                      value={values.registration_code}
                      name="registration_code"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="text"
                    />
                    <Form.Control.Feedback
                      type={errors.registration_code ? 'invalid' : 'valid'}
                    >
                      {touched.registration_code && errors.registration_code}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}

                {isLegal ? (
                  <Form.Group as={Col} sm={6}>
                    <Form.Label>شماره اقتصادی جدید</Form.Label>
                    <Form.Control
                      disabled
                      placeholder={''}
                      // isInvalid={
                      //   touched.economical_number && errors.economical_number
                      // }
                      // isValid={
                      //   touched.economical_number && !errors.economical_number
                      // }
                      value={values.national_id}
                      name="national_id"
                      // onChange={handleChange}
                      // onBlur={handleBlur}
                      type="text"
                    />
                    {/* <Form.Control.Feedback
                      type={errors.economical_number ? 'invalid' : 'valid'}
                    >
                      {touched.economical_number && errors.economical_number}
                    </Form.Control.Feedback> */}
                  </Form.Group>
                ) : (
                  <Form.Group as={Col} sm={12}>
                    <Form.Label>شماره اقتصادی </Form.Label>
                    <Form.Control
                      placeholder={''}
                      isInvalid={
                        touched.economical_number && errors.economical_number
                      }
                      isValid={
                        touched.economical_number && !errors.economical_number
                      }
                      value={values.economical_number}
                      name="economical_number"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="text"
                    />
                    <div className="fs--2 mt-1">
                      <>
                        به عنوان شخص حقیقی می‌توانید وارد
                        <a
                          href="https://tax.gov.ir/action/do/InquiryNationalID"
                          rel="noopener nofollow"
                          target="_blank"
                        >
                          &nbsp; این آدرس&nbsp;
                        </a>
                        شوید و شماره اقتصادی خود را دریافت کنید (حتما باید گام ۴
                        باشید در غیر این صورت امکان صدور فاکتور رسمی نیست).
                      </>{' '}
                    </div>
                    <Form.Control.Feedback
                      type={errors.economical_number ? 'invalid' : 'valid'}
                    >
                      {touched.economical_number && errors.economical_number}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Row>
              <Row className="g-2 mb-3">
                <Form.Group as={Col} sm={6}>
                  <Form.Label>استان</Form.Label>
                  <Form.Control
                    placeholder={''}
                    isInvalid={touched.province && errors.province}
                    isValid={touched.province && !errors.province}
                    value={values.province}
                    name="province"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="text"
                  />
                  <Form.Control.Feedback
                    type={errors.province ? 'invalid' : 'valid'}
                  >
                    {touched.province && errors.province}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} sm={6}>
                  <Form.Label>شهر</Form.Label>
                  <Form.Control
                    placeholder={''}
                    isInvalid={touched.city && errors.city}
                    isValid={touched.city && !errors.city}
                    value={values.city}
                    name="city"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="text"
                  />
                  <Form.Control.Feedback
                    type={errors.city ? 'invalid' : 'valid'}
                  >
                    {touched.city && errors.city}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="g-2 mb-3">
                <Form.Group as={Col} sm={6}>
                  <Form.Label>کدپستی</Form.Label>
                  <Form.Control
                    placeholder={''}
                    isInvalid={touched.postal_code && errors.postal_code}
                    isValid={touched.postal_code && !errors.postal_code}
                    value={values.postal_code}
                    name="postal_code"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="text"
                  />
                  <Form.Control.Feedback
                    type={errors.postal_code ? 'invalid' : 'valid'}
                  >
                    {touched.postal_code && errors.postal_code}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} sm={6}>
                  <Form.Label>شماره تلفن</Form.Label>
                  <Form.Control
                    maxLength={max}
                    placeholder={''}
                    isInvalid={touched.phone_number && errors.phone_number}
                    isValid={touched.phone_number && !errors.phone_number}
                    value={values.phone_number}
                    name="phone_number"
                    onChange={e => {
                      if (e.target.value.startsWith('0')) setmax(11);
                      if (e.target.value.startsWith('+98')) setmax(13);
                      setFieldValue(
                        'phone_number',
                        String(e.target.value).toEnglishDigit()
                      );
                    }}
                    onBlur={handleBlur}
                    type="text"
                  />
                  <Form.Control.Feedback
                    type={errors.phone_number ? 'invalid' : 'valid'}
                  >
                    {touched.phone_number && errors.phone_number}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="g-2 mb-3">
                <Form.Group as={Col}>
                  <Form.Label>نشانی</Form.Label>
                  <Form.Control
                    placeholder={''}
                    isInvalid={touched.address && errors.address}
                    isValid={touched.address && !errors.address}
                    value={values.address}
                    name="address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="text"
                    as="textarea"
                    rows={3}
                  />
                  <Form.Control.Feedback
                    type={errors.address ? 'invalid' : 'valid'}
                  >
                    {touched.address && errors.address}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Form.Group className="">
                <Form.Check
                  isInvalid={isAgreedWithTermsError}
                  type="checkbox"
                  id="agreedToTerms"
                  className="mb-0"
                >
                  <Form.Check.Input
                    isInvalid={isAgreedWithTermsError}
                    type="checkbox"
                    name="agreedToTerms"
                    onChange={({ target }) => {
                      if (isAgreedWithTermsError && target.checked)
                        setIsAgreedWithTermsError(false);
                      setAgreedWithTerms(target.checked);
                    }}
                    checked={agreedWithTerms}
                  />
                  <Form.Check.Label className="mb-0 cursor-pointer ms-1">
                    اطلاع دارم که پس از ثبت اطلاعات و صدور فاکتور، امکان ویرایش
                    اطلاعات فاکتور صادر شده وجود ندارد؛ و از صحت اطلاعات فوق
                    اطمینان کامل را دارم.
                  </Form.Check.Label>
                  <Form.Control.Feedback type="invalid" className="mt-0">
                    شرط صدور فاکتور رو در صورت موافقت تیک بزنید.
                  </Form.Control.Feedback>
                </Form.Check>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Check
                  isInvalid={isAgreedWithTermsError1}
                  type="checkbox"
                  id="agreedToTerms1"
                  className="mb-0"
                >
                  <Form.Check.Input
                    isInvalid={isAgreedWithTermsError1}
                    type="checkbox"
                    name="agreedToTerms1"
                    onChange={({ target }) => {
                      if (isAgreedWithTermsError1 && target.checked)
                        setIsAgreedWithTermsError1(false);
                      setAgreedWithTerms1(target.checked);
                    }}
                    checked={agreedWithTerms1}
                  />
                  <Form.Check.Label className="mb-0 cursor-pointer ms-1">
                    تأیید می‌کنم که از زمان ثبت اطلاعات جدید، سفارش‌های بعدی بر
                    اساس این اطلاعات صادر می‌شوند و سفارش‌های پیشین قابل ویرایش
                    یا تطبیق با این اطلاعات نخواهند بود.
                  </Form.Check.Label>
                  <Form.Control.Feedback type="invalid" className="mt-0">
                    شرط صدور فاکتور رو در صورت موافقت تیک بزنید.
                  </Form.Control.Feedback>
                </Form.Check>
              </Form.Group>

              <Flex
                className="gap-3 mt-3"
                justifyContent="end"
                alignItems="center"
              >
                <Flex className="gap-3" alignItems="center">
                  <Button variant="secondary" onClick={handleClose}>
                    بستن
                  </Button>
                  <Button
                    type="submit"
                    className="text-nowrap"
                    variant="falcon-primary"
                  >
                    {init ? 'ویرایش اطلاعات' : ' ثبت اطلاعات'}
                  </Button>
                </Flex>
              </Flex>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default LegalForm;
